<template>
  <div
    class="max-w-sm rounded-lg overflow-hidden shadow-lg bg-base-100 transform transition-transform duration-300 hover:scale-105 hover:cursor-pointer"
    @click="$router.push(`/publications/${property.id}`)">
    <!-- Property Image -->
    <div class="relative">
      <img class="w-full h-48 object-cover" :src="propertyImage" :alt="property.titulo">
      
      <!-- Top right buttons -->
      <div class="absolute top-2 right-2 flex gap-2">
        <ComparisonButton :property="property" :show-text="false" />
        <button class="p-2 rounded-full bg-base-100"
          @click.stop="toggleFavorite">
          <svg v-if="isFavorite" xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-red-500 transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-gray-400 hover:text-red-500 transition-colors duration-300" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Property Details -->
    <div class="px-4 py-3">

      <!-- Price -->
      <div class="flex items-baseline mb-1">
        <h2 class="text-2xl font-bold text-primary">{{ property.precio }}</h2>
        <span class="text-sm text-secondary ml-1">USD</span>
      </div>

      <!-- Address -->
      <p class="text-sm font-bold mb-3 text-secondary truncate">{{ property.ubicacion }}</p>

      <!-- Features -->
      <div class="flex flex-wrap gap-4 mb-3">
        <div class="flex items-center">
          <div class="w-5 h-5 mr-1 flex items-center justify-center text-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <span class="text-xs text-secondary">{{ property.totalArea || 0 }} m² totales</span>
        </div>
        <div class="flex items-center">
          <div class="w-5 h-5 mr-1 flex items-center justify-center text-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
          </div>
          <span class="text-xs text-secondary">{{ property.habitaciones || 0 }} hab.</span>
        </div>
        <div class="flex items-center">
          <div class="w-5 h-5 mr-1 flex items-center justify-center text-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <span class="text-xs text-secondary">{{ property.banos || 0 }} baños</span>
        </div>
      </div>

      <!-- Title -->
      <h2 class="text-sm font-medium mb-2 text-primary">
        {{ property.titulo }}
      </h2>

      <!-- Description -->
      <!-- <p class="text-sm text-secondary mb-1 whitespace-break-spaces line-clamp-3">{{ property.descripcion }}</p> -->

      <!-- Agent Info -->
      <!-- <div class="flex items-center border-t pt-3 border-gray-200">
        <img class="w-12 h-12 rounded-full mr-3" :src="agentPhotoUrl" :alt="agentName">
        <div>
          <p class="font-medium text-primary">{{ agentName }}</p>
          <p class="text-sm text-secondary">{{ agentAgency }}</p>
        </div>
      </div> -->

      <!-- Contact Buttons -->
      <!-- <div class="flex justify-start mt-3 space-x-2">
        <a href="#" class="w-10 h-10 flex items-center justify-center rounded-full bg-green-500 text-white">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </a>
        <a href="#" class="w-10 h-10 flex items-center justify-center rounded-full bg-blue-500 text-white">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
        </a>
        <a href="#" class="w-10 h-10 flex items-center justify-center rounded-full bg-blue-400 text-white">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
import ComparisonButton from './ComparisonButton.vue'

export default {
  name: 'PropertyCard',
  components: {
    ComparisonButton
  },
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFavorite: this.property.is_favorite
    }
  },
  watch: {
    'property.is_favorite'(val) {
      this.isFavorite = val
    }
  },
  methods: {
    async toggleFavorite() {
      if (!this.$store.getters['auth/isAuthenticated']) {
        this.$router.push({ name: 'login' })
        return
      }

      this.isFavorite = !this.isFavorite // Cambia el estado local inmediatamente
      try {
        await this.$store.dispatch('favorites/TOGGLE_FAVORITE', this.property.id)
      } catch (e) {
        // Si hay error, revierte el cambio local
        this.isFavorite = !this.isFavorite
      }
    }
  },
  computed: {
    propertyImage() {
      return this.property.imagenes && this.property.imagenes.length ? this.property.imagenes[0].imagen : ''
    },
    agentPhotoUrl() {
      return this.property.agent ? this.property.agent.photoUrl : ''
    },
    agentName() {
      return this.property.agent ? this.property.agent.name : 'Agente Desconocido'
    },
    agentAgency() {
      return this.property.agent ? this.property.agent.agency : 'Inmobiliaria Desconocida'
    }
  }
}
</script>

<style scoped>
.text-primary {
  color: var(--text-primary-color);
}

.text-secondary {
  color: var(--text-secondary-color);
}
</style>
